export default __webpack_public_path__ + "static/media/boy6.161de808.png";